import { Box, Button, Grid, Modal } from "@mui/material";
import { Formik } from "formik";
import React, { useState } from "react";
import { object, string } from "yup";

import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import { useMutation } from "react-query";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import {
  AddOfficePost,
  EditOfficePost,
} from "../../../services/officePosts.service";
// import { ChildOrSibling } from "./sortableTreeCmp";
import { v4 as uuid } from "uuid";

type ChildOrSibling = "child" | "sibling" | "update" | "firstTime";
const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },

  maxHeight: "70vh",
  // minHeight: "30vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,

  borderRadius: "5px",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

interface Props {
  setOpenAddCategory: any;
  openAddCategory: boolean;
  addNodeCild?: any;
  addNodeSibling?: any;
  updateNode?: any;
  rowInfo?: any;
  childOrSibling?: ChildOrSibling;
  setFirstTimeView?: any;
  setUpdateTree?: any;
  setSearchQuery?: any;
  setSearchById?: any;
}

const SetNewCategoryModal = ({
  setOpenAddCategory,
  openAddCategory,
  addNodeCild,
  addNodeSibling,
  updateNode,
  rowInfo,
  childOrSibling,
  setFirstTimeView,
  setUpdateTree,
  setSearchQuery,
  setSearchById,
}: Props) => {
  const [isActive, setActivtion] = useState(false);

  const addNewCategoryInit = {
    title: childOrSibling === "update" ? rowInfo?.node.title : "",
  };
  const addNewCategoryValidation = object().shape({
    title: string()
      .ensure()
      .required("لطفا عنوان سازمانی را وارد نمایید")
      .max(250, "عنوان سازمانی نباید بیش از 250 کاراکتر یاشد"),
  });

  const { mutate: AddOfficePostMutate } = useMutation(AddOfficePost, {
    onSuccess: (data: { id: number }) => {
      if (data) {
        // DATA STORE IN STATE
        setSearchById(true);
        setSearchQuery(data.id);
        setUpdateTree(uuid());
      }
    },
    onError: () => {},
  });
  const { mutate: EditOfficePostMutate } = useMutation(EditOfficePost, {
    onSuccess: (data: boolean) => {
      if (data) {
        // DATA STORE IN STATE
        setSearchById(true);
        setSearchQuery(rowInfo.node.id);
        setUpdateTree(uuid());
      }
    },
    onError: () => {},
  });

  const handleAddCategory = (values: any) => {
    setOpenAddCategory(false);
    let title = (
      <span className={!isActive ? "inActive-node-style" : ""}>
        {!isActive && <DoDisturbIcon sx={{ marginLeft: "7px" }} />}
        {values.title}
      </span>
    );

    if (childOrSibling !== "update") {
      AddOfficePostMutate({
        name: null,
        parentOfficePostId:
          childOrSibling === "sibling"
            ? rowInfo.parentNode === undefined
              ? null
              : rowInfo.parentNode.id
            : rowInfo.node.id,
        title: values.title,
      });
    } else {
      EditOfficePostMutate({
        name: null,
        title: values.title,
        officePostId: rowInfo.node.id,
        parentOfficePostId: rowInfo.node.parentOfficePostId,
      });
    }

    // setFirstTimeView(false);
    setActivtion(false);
  };

  return (
    <div>
      <Modal
        open={openAddCategory}
        onClose={() => {
          setOpenAddCategory(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={deactiveUserStyle}>
          <Grid
            container
            flexDirection={"column"}
            justifyContent={"space-between"}
            alignItems={"center"}
            gap={"3.8rem"}
          >
            <Grid item width={"100%"}>
              <Formik
                initialValues={addNewCategoryInit}
                onSubmit={handleAddCategory}
                validateOnMount={true}
                validationSchema={addNewCategoryValidation}
              >
                {({
                  handleSubmit,
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Grid
                      container
                      flexDirection={"column"}
                      gap={"15px"}
                      width={"100%"}
                    >
                      <Grid item marginBottom={"20px"}>
                        <MaterialTextFieldComponent
                          placeHolder={"عنوان سازمانی"}
                          label={"عنوان سازمانی"}
                          required={true}
                          name={"title"}
                          id={"title"}
                          autoFocus={true}
                          helperText={touched.title ? errors.title : ""}
                          error={touched.title && Boolean(errors.title)}
                          value={values.title}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </Grid>

                      <Grid item width={"100%"}>
                        <Grid
                          container
                          flexDirection={"row"}
                          justifyContent={"space-between"}
                          // gap={"1rem"}
                        >
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={6}
                            maxWidth={{ xs: "unset", md: "160px !important" }}
                          >
                            <Button
                              fullWidth
                              variant="contained"
                              type="submit"
                              disabled={
                                !values.title ||
                                values.title === rowInfo.node.title
                              }
                              className={
                                !values.title ||
                                values.title === rowInfo.node.title
                                  ? "btnForm disabledBtn"
                                  : "btnForm SuccessDefault"
                              }
                            >
                              تایید و ادامه
                            </Button>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={6}
                            maxWidth={{ xs: "unset", md: "160px !important" }}
                            sx={{ marginTop: { xs: "10px", md: "0px" } }}
                          >
                            <Button
                              fullWidth
                              variant="contained"
                              style={{
                                fontSize: "1rem",
                                color: "#fff",
                                height: "40px",
                                background: "#607D8B",
                              }}
                              onClick={() => {
                                setOpenAddCategory(false);
                              }}
                            >
                              بازگشت
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </form>
                )}
              </Formik>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
};

export default SetNewCategoryModal;
